<template>
  <div class="rule-item-box">
    <div class="rule-item-orgin">
      <span class="rule-item-rogin-tit">{{ $t('message["61"]') }}</span>
      <a-select
        class="relation-orign-sel"
        :placeholder="infoFromTit"
        :default-value="valKey"
        @change="handleChange"
      >
        <a-select-option
          v-for="(val) in datas"
          :key="val.fieldkey"
          :disabled="val.disabled"
          :value="val.fieldkey"
        >
          {{ val.fieldname }}
        </a-select-option>
      </a-select>
    </div>
    <div v-if="isText">
      <span class="txt-box rule-item-rogin-tit">{{ txt }}</span>
      <a-form-item>
        <a-textarea
          :default-value="value && value.join(',')"
          class="relation-orign-sel"
          :placeholder="textareaPlace"
          :autosize="{ minRows: 6, maxRows: 10 }"
          @change="textareaChange"
        />
      </a-form-item>
    </div>
    <div v-if="fieldType === 'select'">
      <span class="txt-box rule-item-rogin-tit">{{ txt }}</span>
      <a-form-item class="field-select-item">
        <a-select
          v-decorator="[
            `${index}${key}select`,
            {rules: [{ required: true, message: selectNeedTip }], initialValue: value}
          ]"
          mode="multiple"
          :filter-option="false"
          class="relation-orign-sel"
          :placeholder="selectPlaceholder"
          @change="selectChange"
          @search="handleSearch"
          @deselect="searchM"
        >
          <a-select-option
            v-for="item2 in selectDatas"
            :key="item2.id"
            :value="item2.id"
          >
            {{ item2.name }}
          </a-select-option>
        </a-select>
      </a-form-item>
    </div>
    <a
      href="javascript:;"
      class="del-sel-rule iconicon-test8 iconfont"
      @click="delSelectItem"
    />
  </div>
</template>
<script>
import { cloneDeep } from 'lodash'
export default {
  props: {
    datas: {
      type: Object,
      default () {
        return {}
      }
    },
    index: {
      type: Number,
      default () {
        return 0
      }
    },
    valKey: {
      type: String,
      default: ''
    },
    value: {
      type: Array,
      default () {
        return []
      }
    },
    item: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      fieldType: '',
      key: this.valKey,
      selectDatas: [],
      cloneSelectDatas: []
    }
  },
  computed: {
    isText () {
      return this.fieldType === 'text' || this.fieldType === 'tag'
    },
    txt () {
      const { contains } = this
      const txt = this.isText ? contains[0] : contains[1]
      return txt
    },
    // selectDatas2 () {
    //   let arr = []
    //   const { datas } = this
    //   for (let key in datas) {
    //     if (this.key === key && datas[key].fieldtype === 'select') {
    //       arr = datas[key].options
    //     }
    //   }
    //   return arr
    // },
    contains () {
      return this.$t('message["20"]').split('|')
    },
    selectPlaceholder () {
      return this.$t('message["866"]')
    },
    infoFromTit () {
      return this.$t('message["1370"]')
    },
    textareaPlace () {
      return this.$t('message["1405"]')
    },
    selectNeedTip () {
      return this.$t('message["855"]')
    }
  },
  watch: {
    fieldType (val) {
      let arr = []
      const { datas } = this
      for (let key in datas) {
        if (this.key === key && datas[key].fieldtype === 'select') {
          arr = datas[key].options
        }
      }
      this.selectDatas = arr
      this.cloneSelectDatas = cloneDeep(arr)
    }
  },
  mounted () {
    this.getkey(this.valKey)
  },
  methods: {
    handleChange (val, option) {
      this.getkey(val)
      this.key = val
      this.$delete(this.item, this.valKey)
      this.$set(this.item, val)
    },
    getkey (val) {
      const { datas } = this
      for (let key in datas) {
        if (datas[key].fieldkey === val) {
          this.fieldType = datas[key].fieldtype
        }
      }
    },
    selectChange (val) {
      this.$set(this.item, this.valKey, val)
    },
    delSelectItem () {
      this.$delete(this.item, this.valKey)
    },
    textareaChange (val) {
      this.$set(this.item, this.valKey, val.target.value.split(','))
    },
    handleSearch (val) {
      const { cloneSelectDatas } = this
      val = val.trim()
      if (val) {
        this.selectDatas = cloneSelectDatas.filter(item => item.name.toString().indexOf(val) > -1)
      } else {
        this.selectDatas = cloneSelectDatas
      }
    },
    searchM (value) {
      this.selectDatas = this.cloneSelectDatas
    }
  }
}
</script>
<style lang="scss" scoped>
 .relation-orign-sel {
    width: 320px;
    margin-left:18px;
  }
  .rule-item-box {
    border: 1px dashed #d6d6d6;
    padding: 24px 20px 24px 20px;
    margin-bottom: 24px;
    margin-left: 56px;
    border-radius: 4px;
    position: relative;
    .rule-item-rogin-tit {
      width: 60px;
      text-align: right;
      display: inline-block;
    }
    .del-sel-rule {
      position: absolute;
      right: 24px;
      top: 28px;
      color: #d6d6d6;
      font-size: 16px;
    }
  }
  .rule-item-orgin {
    margin-bottom: 16px;
  }
  .txt-box {
    display: inline-block;
    line-height: 32px;
    margin-right: 3px;
  }
  .field-select-item::v-deep {
    .ant-form-explain {
    margin:4px 0 0 17px;
    }
  }
</style>
